/**
 * Asynchronously loads the component for NotAvailablePage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
